import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { SwiperContainer } from 'swiper/element';
import { SwiperOptions } from 'swiper/types';

@Directive({
  selector: '[plSwiper]',
  standalone: true,
})
export class SwiperDirective implements AfterViewInit {
  private readonly swiperElement: SwiperContainer;

  @Input() public config?: SwiperOptions;

  constructor(private el: ElementRef<HTMLElement>) {
    this.swiperElement = el.nativeElement as SwiperContainer;
  }

  public ngAfterViewInit(): void {
    Object.assign(this.swiperElement, this.config);
    this.swiperElement.initialize();
  }
}
